import './App.css';

import Navbar from './components/Navbar';
import FloatingSidebar from './components/FloatingSidebar';

import Header from './components/Header';
import Master from './components/Master';
import Trailer from './components/Trailer';
import StudyMethod from './components/StudyMethod';
import Memberships from './components/Memberships';
import Financing from './components/Financing';
import Counseling from './components/Counseling';
import FAQ from './components/FAQ';
import HeaderForm from './components/HeaderForm';
import FooterNew from './components/FooterNew';

function App() {
	return (
		<main className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			<HeaderForm />
			<Master />
			<Trailer />
			<StudyMethod />
			<Memberships />
			<Financing />
			<Counseling />
			<FAQ />
			<FooterNew />
		</main>
	);
}

export default App;
